import React, { useState } from 'react';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { label: 'Home', href: '#home' },
    { label: 'Services', href: '#services' },
    { label: 'North America', href: '#north-america' },
    { label: 'Databricks', href: '#databricks' },
    { label: 'Power Platform', href: '#power-platform' },
    { label: 'AI Consulting', href: '#ai-consulting' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <a href="#home" className="text-2xl font-bold text-primary tracking-tight">
            Spiked<span className="text-secondary">Qcumber</span>
          </a>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center space-x-6">
            {links.map(link => (
              <a
                key={link.href}
                href={link.href}
                className="text-gray-600 hover:text-primary text-sm font-medium transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              className="bg-primary text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-blue-900 transition-colors"
            >
              Get Started
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden text-gray-600 focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              }
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="lg:hidden pb-4 space-y-2">
            {links.map(link => (
              <a
                key={link.href}
                href={link.href}
                className="block px-2 py-2 text-gray-700 hover:text-primary font-medium"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              className="block mt-2 bg-primary text-white px-5 py-2 rounded-full text-sm font-semibold text-center"
              onClick={() => setMenuOpen(false)}
            >
              Get Started
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
